import { DATE_FORMAT } from '@utils/constants';
import dayjs, { Dayjs } from 'dayjs';

export const dateTypeToData = ({
  type,
  date,
  data,
  dataKey,
  empty
}: {
  type: 'MONTH' | 'YEAR';
  date: Dayjs;
  data?: any[];
  dataKey: string;
  empty?: any;
}) => {
  const dataConvert = (data || [])?.reduce(
    (p, c) => ({
      ...p,
      [type === 'MONTH' ? c[dataKey] : dayjs(c[dataKey], DATE_FORMAT).endOf('month').format(DATE_FORMAT)]: c
    }),
    {}
  );
  const obj = {
    MONTH: Array.from({ length: date.daysInMonth() })?.reduce<Record<string, any>>((p, c, i) => {
      const dateString = date.add(i, 'day').format(DATE_FORMAT);

      return {
        ...p,
        [dateString]: {
          ...(dataConvert?.[dateString] ? dataConvert?.[dateString] : { ...empty, [dataKey]: dateString })
        }
      };
    }, {}),
    YEAR: Array.from({ length: 12 })?.reduce<Record<string, any>>((p, c, i) => {
      const dateString = date.startOf('year').add(i, 'month').endOf('month').format(DATE_FORMAT);

      return {
        ...p,
        [dateString]: {
          ...(dataConvert?.[dateString] ? dataConvert?.[dateString] : { ...empty, [dataKey]: dateString })
        }
      };
    }, {})
  };

  return obj[type];
};
